export interface StatusStyle {
  text: string;
  /** pill 背景 */
  bg: string;
  /** 文字色 */
  fg: string;
  /** 狀態小圓點 */
  dot: string;
}

/** 狀態 → 柔和 pill 樣式（淺色底 + 深色字 + 小圓點）。 */
const DRAFT: StatusStyle = { text: '草稿', bg: '#f1f2f4', fg: '#5b6470', dot: '#9aa3af' };
const SCHEDULED: StatusStyle = { text: '已排程', bg: '#e8f1ff', fg: '#1d5fc4', dot: '#3b82f6' };
const PUBLISHED: StatusStyle = { text: '已發佈', bg: '#e7f6ee', fg: '#0f7a44', dot: '#16a34a' };

export const STATUS: Record<string, StatusStyle> = {
  draft: DRAFT,
  // 「審稿中」流程已取消：舊資料的 in_review 一律顯示為草稿（DB enum 保留）。
  in_review: DRAFT,
  scheduled: SCHEDULED,
  published: PUBLISHED,
};

/** 列表篩選選項（不含 in_review；篩「草稿」時後端會一併包含舊的 in_review）。 */
export const STATUS_OPTIONS = [
  { value: 'draft', label: DRAFT.text },
  { value: 'scheduled', label: SCHEDULED.text },
  { value: 'published', label: PUBLISHED.text },
];

export const fmtTaipei = (t: number | string) =>
  new Date(t).toLocaleString('zh-TW', {
    timeZone: 'Asia/Taipei',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
